export default __webpack_public_path__ + "media/shaker-manifesto-logo2.e563b00d.PNG";